export default "__VITE_ASSET__Dvgy_uac__"